import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const UnActiveSubscription = ({
  setShowSubscriptionModal,
  showSubscriptionModal,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <>
      {showSubscriptionModal && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black bg-opacity-60">
          <div className="bg-white dark:bg-[#252739] w-[90%] max-w-md rounded-xl p-6 shadow-2xl text-center relative border-white dark:border-dark-border border-2">
            {/* Logo positioned above modal */}
            <div className="absolute -top-8 left-1/2 transform -translate-x-1/2">
              <img 
                src="/logo-bg.png"
                alt="VibeLinks" 
                className="h-16 w-16 sm:h-20 sm:w-20 object-contain" 
              />
            </div>
            
            <div className="pt-12">
              <h2 className="text-black dark:text-dark-text text-xl font-bold mb-2">
                {t("subscription_modal.title")}
              </h2>
              <p className="text-black dark:text-dark-text mb-6">
                {t("subscription_modal.message")}
              </p>
              <div className="flex gap-4 justify-center">
                <button
                  className="bg-[#e85a59] text-white rounded-lg font-bold py-2 px-8 text-lg transition hover:opacity-90"
                  onClick={() => setShowSubscriptionModal(false)}
                >
                  {t("subscription_modal.cancel")}
                </button>
                <button
                  className="bg-[#6d2af6] text-white rounded-lg font-bold py-2 px-8 text-lg transition hover:opacity-90"
                  onClick={() => {
                    setShowSubscriptionModal(false);
                    navigate("/subscription");
                  }}
                >
                  {t("subscription_modal.buy")}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default UnActiveSubscription;
